<template>
	<div class="order">
		<div class="btnbox"></div>
		<div class="tablebox">
			<div class="filterdiv filterty" ref="filter">
				<el-form :inline="true" :model="formfilter" class="demo-form-inline" size="small" label-width="0"
					v-if="filtershow">
					<el-form-item label="" prop="shop_id">
						<el-select v-model="formfilter.shop_id" placeholder="请选择渠道">
							<el-option label="渠道" value=""></el-option>
							<el-option :label="v.name" :value="v.id" v-for="(v,k) in qudao" :key="k">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" @click="onfilter">查询</el-button>
						<el-button @click="onreset">重置</el-button>
					</el-form-item>
				</el-form>
			</div>
			<div class="zk" @click="filtershow=!filtershow ">
				<span>{{filtershow ? '收起':'展开'}}</span>
			</div>
			<div class="tablediv" ref="tablediv">
				<el-table :data="list" style="width: 100%" border height="100%">
					<el-table-column prop="shop_name" fixed="left" label="渠道" align="center" header-align="center">
					</el-table-column>
					<el-table-column prop="trade_no" label="订单号" align="center" header-align="center">
					</el-table-column>
					<el-table-column prop="state_str" label="状态" align="center" header-align="center">
					</el-table-column>
					<el-table-column prop="err_msg" label="错误信息" align="center" header-align="center" :show-overflow-tooltip="true">
					</el-table-column>
					<el-table-column prop="create_time_str" fixed="right" label="创建时间" align="center" header-align="center">
					</el-table-column>
				</el-table>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'jorder',
		data() {
			return {
				list: [],
				page: 1,
				pageSize: 20,
				total: 0,
				filtershow: true,
				formfilter: {
					shop_id: ""
				},
				qudao: [],
			}
		},
		
		mounted() {
			this.onlist();
			this.onqudao();
			this.resizeObserver = new ResizeObserver(entries => {
				for (let entry of entries) {
					const cr = entry.contentRect;
					var num = Number(cr.height) + 30;
					this.$refs.tablediv.style.height = "calc(100% - " + num + "px)";
				}
			});
			this.resizeObserver.observe(this.$refs.filter);
		},
		
		beforeDestroy() {
			if (this.resizeObserver) {
				this.resizeObserver.disconnect();
			}
		},
		
		methods: {
			handleCurrentChange() {
				this.onlist();
			},
		
			handleSizeChange(val) {
				this.page = 1;
				this.pageSize = val;
				this.onlist();
			},
		
			onfilter() {
				this.page = 1;
				this.onlist();
			},
		
			onreset() {
				this.formfilter = {
					shop_id: ""
				};
				this.page = 1;
				this.onlist();
			},
		
			onlist() {
				var obj = JSON.parse(JSON.stringify(this.formfilter));
				obj.page = this.page;
				obj.limit = this.pageSize;
		
				this.$axios.post('api/jst/order_upload_log', obj).then(res => {
					if (res.data.code == 0) {
						this.total = res.data.data.count;
						this.list = res.data.data.list;
					} else {
						this.$message.error(res.data.message);
					}
				}).catch(err => {
					console.log(err)
				})
			},
		
			onqudao() {
				var obj = {
					code: "",
					name: "",
					state: 2,
					page: 1,
					limit: 99999
				};
		
				this.$axios.post('api/user/shop_list', obj).then(res => {
					if (res.data.code == 0) {
						this.qudao = res.data.data.list;
					} else {
						this.$message.error(res.data.message);
					}
				}).catch(err => {
					console.log(err)
				})
			}
		}
	}
</script>

<style scoped lang="less">
	.order {
		height: 100%;
	}
	
	.tablebox {
		height: calc(100% - 72px);
	}
	
	.tablediv {
		height: 100%;
	}
</style>


// WEBPACK FOOTER //
// src/components/jushuitan/order.vue